export const GET_MENU_ATTRIBUTE_LIST_REQUESTED = 'menuAttribute/GET_MENU_ATTRIBUTE_LIST_REQUESTED';
export const GET_MENU_ATTRIBUTE_LIST_SUCCESS = 'menuAttribute/GET_MENU_ATTRIBUTE_LIST_SUCCESS';
export const GET_MENU_ATTRIBUTE_LIST_FAILURE = 'menuAttribute/GET_MENU_ATTRIBUTE_LIST_FAILURE';

export const ADD_MENU_ATTRIBUTE_REQUESTED = 'menuAttribute/ADD_MENU_ATTRIBUTE_REQUESTED';
export const ADD_MENU_ATTRIBUTE_SUCCESS = 'menuAttribute/ADD_MENU_ATTRIBUTE_SUCCESS';
export const ADD_MENU_ATTRIBUTE_FAILURE = 'menuAttribute/ADD_MENU_ATTRIBUTE_FAILURE';

export const UPDATE_MENU_ATTRIBUTE_REQUESTED = 'menuAttribute/UPDATE_MENU_ATTRIBUTE_REQUESTED';
export const UPDATE_MENU_ATTRIBUTE_SUCCESS = 'menuAttribute/UPDATE_MENU_ATTRIBUTE_SUCCESS';
export const UPDATE_MENU_ATTRIBUTE_FAILURE = 'menuAttribute/UPDATE_MENU_ATTRIBUTE_FAILURE';

export const DELETE_MENU_ATTRIBUTE_REQUESTED = 'menuAttribute/DELETE_MENU_ATTRIBUTE_REQUESTED';
export const DELETE_MENU_ATTRIBUTE_SUCCESS = 'menuAttribute/DELETE_MENU_ATTRIBUTE_SUCCESS';
export const DELETE_MENU_ATTRIBUTE_FAILURE = 'menuAttribute/DELETE_MENU_ATTRIBUTE_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  menuAttributeList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_ATTRIBUTE_LIST_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case GET_MENU_ATTRIBUTE_LIST_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
        menuAttributeList: action.result,
      };
    }
    case GET_MENU_ATTRIBUTE_LIST_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
        menuAttributeList: [],
      };
    }
    case ADD_MENU_ATTRIBUTE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case ADD_MENU_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case ADD_MENU_ATTRIBUTE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    case DELETE_MENU_ATTRIBUTE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case DELETE_MENU_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case DELETE_MENU_ATTRIBUTE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getMenuAttributeList = () => {
  return {
    types: [GET_MENU_ATTRIBUTE_LIST_REQUESTED, GET_MENU_ATTRIBUTE_LIST_SUCCESS, GET_MENU_ATTRIBUTE_LIST_FAILURE],
    promise: client => client.get('getMenuAttributeLIst')
  };
};

export const addMenuAttribute = (data) => {
  return {
    types: [ADD_MENU_ATTRIBUTE_REQUESTED, ADD_MENU_ATTRIBUTE_SUCCESS, ADD_MENU_ATTRIBUTE_FAILURE],
    promise: client => client.post('addMenuAttribute', { data })
  };
};

export const updateMenuAttribute = (data) => {
  return {
    types: [UPDATE_MENU_ATTRIBUTE_REQUESTED, UPDATE_MENU_ATTRIBUTE_SUCCESS, UPDATE_MENU_ATTRIBUTE_FAILURE],
    promise: client => client.post('updateMenuAttribute', { data })
  };
};

export const deleteMenuAttribute = (menuAttributeId) => {
  return {
    types: [DELETE_MENU_ATTRIBUTE_REQUESTED, DELETE_MENU_ATTRIBUTE_SUCCESS, DELETE_MENU_ATTRIBUTE_FAILURE],
    promise: client => client.post(`deleteMenuAttribute/${menuAttributeId}`)
  };
};
